import { render, staticRenderFns } from "./AddExpense.vue?vue&type=template&id=c53556e6&scoped=true"
import script from "./AddExpense.vue?vue&type=script&lang=js"
export * from "./AddExpense.vue?vue&type=script&lang=js"
import style0 from "./AddExpense.vue?vue&type=style&index=0&id=c53556e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53556e6",
  null
  
)

export default component.exports